import React from 'react';
import activitiesPostTopics from './activitiesPostTopics';
import Activity from './Activity';
import ActivityCommentCard from './ActivityCommentCard';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import { useGetUser } from '../user/useAllUsers';
import omitNonTopics from '../utils/omitNonTopics';
import Link from '../utils/router/Link';
import postPath from '../utils/url/postPath';
import userPath from '../utils/url/userPath';

const ACTIVITY_REPLIED_COMMENT_ACTIVITY_FRAGMENT = gql(`
  fragment ActivityRepliedComment_activity on RepliedCommentActivity {
    actedAt
    actor {
      ...useGetUser_user
    }
    repliedComment {
      ...ActivityCommentCard_comment
      # eslint-disable-next-line @graphql-eslint/require-selections
      thread {
        post {
          id
          ...postPath_post
          topics {
            ...activitiesPostTopics_topics
          }
        }
      }
    }
  }
`);

interface ActivityRepliedCommentProps {
  activity: DocumentType<typeof ACTIVITY_REPLIED_COMMENT_ACTIVITY_FRAGMENT>;
}

const ActivityRepliedComment = ({ activity }: ActivityRepliedCommentProps) => {
  const { actedAt, repliedComment } = activity;
  const post = repliedComment?.thread?.post;

  const getUser = useGetUser();

  const path = post && postPath(post);

  if (!activity.actor) {
    return null;
  }

  const actor = getUser(activity.actor);

  return (
    <Activity
      actor={actor}
      actedAt={actedAt}
      action="COMMENT_REPLY"
      title={
        <>
          <Link to={userPath(actor)}>{actor?.name}</Link> replied to a comment
          in {path && <Link to={path}> {post?.title}</Link>}
        </>
      }
      meta={activitiesPostTopics(post ? omitNonTopics(post.topics) : null)}
    >
      {repliedComment && <ActivityCommentCard comment={repliedComment} />}
    </Activity>
  );
};

export default ActivityRepliedComment;
